export default {
  utility: {
    title: '简介',
    titleP1:`
    为了方便用户进行计算的前、后处理，PWmat安装包内附带了一系列实用程序（utilities）。
    通过这些程序，我们可以实现PWmat结构文件和其他常见晶体结构文件之间的相互转换、处理数据得到可视化电荷密度、能带结构图、投影态密度、真空能级等操作。
    `,
    titleP2: '只需要加载PWmat环境，便可以使用所有的实用程序，加载方法如下（附源代码）：',
    titlePre01: '#自行安装PWmat并配置过环境变量的用户可以直接使用相应程序（以处理能带结构图为例）：',
    titlePre02: '#未安装过PWmat的用户需要先加载PWmat环境再使用相应程序（以处理能带结构图为例）：',
    title2: '下载链接',
    menu1: '格式转换',
    menu2: '数据可视化',
    menu3: '数据后处理',
    tableR0C1: '名称',
    tableR0C2: '简介',
  }
}